export const COPY_SUCCESS = 'Your phrase has been copied to your clipboard';
export const COPY_FAILED = 'Press &#8984;+C (Mac) or Ctrl+C (Windows) to copy your passphrase';
